import {
    getProduct,
    listProductFeatures
} from './queries';

import {GraphQLQuery,} from '@aws-amplify/api';
import {
    CreateProductFeature,
    DeleteProductFeature,
    GetProductFeature,
    ListProductFeatures,
    ProductFeature,
    UpdateProductFeature
} from "../types.ts";
import {
    notifyError,
    notifySuccess
} from "../../../components/PlatformNotification";
import {generateClient} from "aws-amplify/api";
import {
    createProductFeature,
    deleteProductFeature,
    updateProductFeature
} from "./mutations.ts";
import {ListRecordsQuery} from "../../../types";
import {moduleConfig} from "../config";


const client = generateClient();


export const fetchRecords = async (query: ListRecordsQuery) => {

    try {
        const response = await client.graphql<GraphQLQuery<ListProductFeatures>>({
                                                                                     query: listProductFeatures,
                                                                                     variables: {
                                                                                         ...query
                                                                                     },
                                                                                 });
        return {
            items: response.data?.listProductFeatures.items,
            nextToken: response.data?.listProductFeatures.nextToken
        };
    } catch (e) {
        console.trace(e);
    }
};

export const fetch = async (id: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<GetProductFeature>>({
                                                                                   query: getProduct,
                                                                                   variables: {id: id},
                                                                               });
        return response.data?.getProductFeature;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const add = async (payload: Omit<ProductFeature, 'id'>) => {
    const { created, createdByUsername, ...createInput } = payload;

    try {
        const response = await client.graphql<GraphQLQuery<CreateProductFeature>>({
                                                                                      query: createProductFeature,
                                                                                      variables: {input: createInput},
                                                                                  });
        console.debug('in the service response', response);
        notifySuccess(`${moduleConfig.titles.singular} created`);
        return response.data?.createProductFeature;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const update = async (id: string, record: ProductFeature) => {
    const { created, createdByUsername, updated, ...updateInput } = record;

    console.debug('IN UPDATE', id, updateInput);

    try {
        const response = await client.graphql<GraphQLQuery<UpdateProductFeature>>({
                                                                                      query: (updateProductFeature),
                                                                                      variables: {input: updateInput},
                                                                                  });
        notifySuccess(`${moduleConfig.titles.singular} updated`)
        return response.data?.updateProductFeature;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const deleteRecord = async (id: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<DeleteProductFeature>>({
                                                                                      query: (deleteProductFeature),
                                                                                      variables: {input: {id: id}},

                                                                                  });
        notifySuccess(`${moduleConfig.titles.singular} deleted`)
        return response.data?.deleteProductFeature;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};
